module.exports = __webpack_public_path__ + "img/dne-pay.76f9301f.svg";